
export const ContentFinderTexts=function(props:{textsMatched:string[], textClicked:(text: string) => void}){
	let items=[];
    for(let i=0;i<props.textsMatched.length;i++){
		items.push(
			<div className="teachers-contentfinder-matchedtext" key={props.textsMatched[i]} onClick={(e)=>props.textClicked(props.textsMatched[i])}>
				{props.textsMatched[i]}
			</div>
		)
	}
	return(
		<div className="teachers-contentfinder-matchedtexts">{items}</div>
	);
};

